import { getCurrentUser } from '../../provider/currentUser';

export default () => getCurrentUser();
